import * as configJson from '../../public/config.json';
export const config = configJson;
